import {TypeBanks, TypeIpGs, TypePrivateNumberAccesses } from "../../api/models";

export let TypeIpGsDisplay: { [index: number]: string } = {};
// TypeIpGsDisplay[TypeIpGs.Sadad] = "enums.TypeIpGs.Sadad";
TypeIpGsDisplay[TypeIpGs.Mellat] = "enums.TypeIpGs.Mellat";
TypeIpGsDisplay[TypeIpGs.AsanPardakht] = "enums.TypeIpGs.AsanPardakht";
// TypeIpGsDisplay[TypeIpGs.Top] = "enums.TypeIpGs.Top";
TypeIpGsDisplay[TypeIpGs.Saman] = "enums.TypeIpGs.Saman";
TypeIpGsDisplay[TypeIpGs.Sepehr] = "enums.TypeIpGs.Sepehr";
TypeIpGsDisplay[TypeIpGs.IdPay] = "enums.TypeIpGs.IdPay";
TypeIpGsDisplay[TypeIpGs.IranKish] = "enums.TypeIpGs.IranKish";
TypeIpGsDisplay[TypeIpGs.Melli] = "enums.TypeIpGs.Melli";
TypeIpGsDisplay[TypeIpGs.ParbadVirtual] = "enums.TypeIpGs.ParbadVirtual";
TypeIpGsDisplay[TypeIpGs.Parsian] = "enums.TypeIpGs.Parsian";
TypeIpGsDisplay[TypeIpGs.Pasargad] = "enums.TypeIpGs.Pasargad";
TypeIpGsDisplay[TypeIpGs.ZarinPal] = "enums.TypeIpGs.ZarinPal";
TypeIpGsDisplay[TypeIpGs.PayIr] = "enums.TypeIpGs.PayIr";
